import React from 'react';
import Explanation from '@/finsight/ui/common/components/Explanations';
import Title from '@/finsight/ui/common/components/Title';
import loanLevelPopoverStyles from './loanLevelPopover.scss';

const LoanLevelPopover = () => {
  const description = (
    <>
      <Title
        isH3
        className={ loanLevelPopoverStyles.explanationTitle }
      >
        ABS-EE Loan-Level Data (filed on EDGAR)
      </Title>
      <div className={ loanLevelPopoverStyles.explanation }>
        Under <a target="_blank" href="https://www.gpo.gov/fdsys/pkg/FR-2014-09-24/pdf/2014-21375.pdf">SEC </a>
        rules, registered ABS offerings backed by residential mortgages, commercial mortgages, auto loans,
        auto leases, and debt securities (including resecuritizations) must comply with asset-level disclosure
        requirements. An ABS issuer that makes an initial bona fide offer on or after November 23,
        2016 must provide asset-level disclosures that are specified in Schedule AL (Item 1125 of Regulation AB)
        and filed on new Form ABS-EE in a standardized tagged format using eXtensible Markup Language
        (<a target="_blank" href="https://www.sec.gov/info/edgar/specifications/absxml.htm">XML</a>).
      </div>
    </>
  );

  return (
    <div className={ loanLevelPopoverStyles.popoverWrapper }>
      <Explanation content={ description } dataTestPrefix="loanLevelPopover" />
    </div>
  );
};

export default LoanLevelPopover;
